/**
 * Pure per-company default rows that are not settings. No database import
 * (used by the Dexie v2 upgrade step as well as `createCompany`).
 */
import type { DriveState, Uuid } from '../types';

/** The Drive state row a brand new (or migrated) company starts with. */
export function emptyDriveState(companyId: Uuid): DriveState {
  return { id: companyId, companyId, folders: null, pendingChanges: 0, needsSignIn: false };
}
